import { defineRule, configure } from 'vee-validate';
import {i18n} from './vue'
import customValidationMessages from './_locales/errorMessages.js'
import { all } from '@vee-validate/rules';
import { commonizeTimeFormat } from '../../vue/shared/typescripts/dates.ts'

Object.entries(all).forEach(([name, rule]) => {
  defineRule(name, rule);
});

export function countDecimals(val) {
  if (Math.floor(val.valueOf()) === val.valueOf()) return 0;
  return val.toString().split(".")[1]?.length || 0;
}

export function convertToDate(dateString) {
  //  Convert a "dd/MM/yyyy" string into a Date object
  let d = dateString.split("/");
  let date = new Date(d[2] + '/' + d[1] + '/' + d[0]);
  return Date.parse(date) && dateString.length == 10
}

export function getHoursMinutes(value) {
  if(!value) {
    return {hours: 0, minutes: 0}
  }
  // Sometimes we get a date and sometimes we get a time string in format "H:M"
  if(typeof(value) == 'object') {
    return {hours: value.getHours(), minutes: value.getMinutes()}
  }
  let parts = value.split(value.includes('h') ? 'h' : ':');
  let hours = parseInt(parts[0]);
  let minutes = parseInt(parts[1]);
  const isPM = value.toUpperCase().includes('PM');
  const isAM = value.toUpperCase().includes('AM');
  if (isPM && hours !== 12) hours += 12;
  if (isAM && hours === 12) hours = 0;
  return {hours: hours, minutes: minutes}
}

export function calculateDates(date, time) {

  // convert selectedDate to locale timezone
  let selectedDateToLocaleTime = new Date(date);
  selectedDateToLocaleTime.setTime( selectedDateToLocaleTime.getTime() + selectedDateToLocaleTime.getTimezoneOffset()*60*1000 );
  let data = getHoursMinutes(time)
  selectedDateToLocaleTime.setHours(data.hours, data.minutes, 0)
  return selectedDateToLocaleTime
}

export function getRegex(type) {
  switch(type ) {
    case 'postal_code':
      return /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
    case 'phone':
      return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    case 'email':
     return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    case 'coordinates':
      return /^([0-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])(,([0-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]))$/
    case 'numeric8':
      return /^(\d{8})$/
  }
}

configure({
  // this will be used to generate messages.
  generateMessage: (context) => {
    const locale = i18n.global.locale
    const messages = customValidationMessages[locale] || customValidationMessages['en']
    let template = messages[context.rule.name] || context.rule.name
    const params = context.rule.params.reduce(
      (obj, param, index) => ({ ...obj, [`param_${index}`]: param }), {}
    )
    const message = template.replace(/\{(\w+)\}/g, (match, key) => params[key] ?? match)
    return `${context.field} ${message}`
  }
});

defineRule('select_option', all['required'])

defineRule('greater_than_zero', (value) => {
  return value > 0
});

defineRule('date_not_in_past', (value, [time]) => {
  const DateNow = new Date();
  return calculateDates(value,time) > DateNow;
});

defineRule('start_date_before_end_date', (value, [end]) => {
  const startDate = new Date(value);
  const endDate = new Date(end);
  return endDate >= startDate ;
});

defineRule('time_not_in_past', (value, [date]) => {
  const DateNow = new Date();
  return calculateDates(date,value) > DateNow;
});

defineRule('date_not_after_end_date', (value, [startTime, endDate, endTime]) => {
  let end_date = calculateDates(endDate, endTime)
  let start_date = calculateDates(value, startTime)
  return end_date > start_date
});

defineRule('not_before_start_time', (value, [startTime]) => {
    if(!value) {
      return false
    }
    const end_time = getHoursMinutes(value)
    const start_time = getHoursMinutes(startTime)
    const now = new Date();
    const check_end_time = now.setHours(end_time.hours, end_time.minutes, 0)
    const check_start_time = now.setHours(start_time.hours, start_time.minutes, 0)

    return check_end_time > check_start_time
});

defineRule('required_if_selected', (value, [ target ]) => {
  return !(target === 'true' && (value === null || value === ''))
});

defineRule('required_if_checked', (value, [ checkBox, trackedName ]) => {
  return !(checkBox === true && (!value  || value == ""))
});

defineRule('decimal_places', (value, [places]) => {
  return countDecimals(value) <= parseInt(places)
})

defineRule('coordinates', (value, [allowBlank = false]) => {
  if (allowBlank && (!value)) {
    return true;
  }
  return getRegex('coordinates').test(value)
})

defineRule('regex', (value, [validationType, fieldName, allowBlank = false]) => {
  if (allowBlank && (!value  || value == "")) {
    return true;
  }
  if (!getRegex(validationType).test(value)) {
    const specificKey = `regex_${validationType}`;
    return i18n.global.te(specificKey) ? i18n.global.t(specificKey) : false;
  }
  return true;
})

defineRule('at_least_one_checked', (value, [checkBoxOne, checkBoxTwo]) => {
  return (checkBoxOne || checkBoxTwo)
})

defineRule('less_than', (value, [max_number]) => {
  return value <= parseInt(max_number);
})





